import { Flower2 } from "lucide-react";
import { useApp } from "../store";

export const Marquee = () => {
  const { c, lang } = useApp();
  const items = (c("marquee_items") || "").split("•").map((s) => s.trim()).filter(Boolean);
  const row = [...items, ...items];

  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-[var(--accent-soft)]/10 py-5"
      style={{ background: "var(--sec-marquee-bg, #12254D)" }}
      aria-hidden="true"
    >
      <div key={lang} className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display italic text-xl sm:text-2xl text-white/80">{item}</span>
            <Flower2 size={16} className="text-[var(--accent)] shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
